export const localizedDistanceUnit = (distance: number, locale: string) =>
  `${distance} ${locale === 'en-us' ? 'miles' : 'km'}`;

export const apiDistanceUnit = (locale: string): 'meters' | 'miles' => {
  switch (locale) {
    case 'en-us':
    case 'en-uk':
    case 'en-lr':
    case 'my-mm':
      return 'miles';
    default:
      return 'meters';
  }
};
